import Marquee from "react-fast-marquee";

const ITEMS = [
  "ITENS QUE CONTAM HISTÓRIAS",
  "PEÇAS ÚNICAS",
  "MEMÓRIAS EM 3D",
  "PRESENTES PERSONALIZADOS",
  "FEITO COM CARINHO",
  "MODERNAS · DELICADAS",
];

export default function EditorialMarquee() {
  return (
    <section
      className="border-y border-[var(--line)] py-6 md:py-8 bg-[var(--bg)]"
      data-testid="editorial-marquee"
    >
      <Marquee gradient={false} speed={35} pauseOnHover={false}>
        {ITEMS.concat(ITEMS).map((item, i) => (
          <span
            key={i}
            className="font-mono-tech text-[13px] md:text-sm text-[var(--ink-2)] mx-10 md:mx-16 inline-flex items-center gap-10"
          >
            {item}
            <span className="text-[var(--accent)]">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
